<prism-toolbar *transloco="let t" id="sh-header-toolbar">
	<span slot="header" id="sh-header-toolbar-header-span">
		<div id="sh-header-toolbar-left-content-div">
			@if (showSidenavToggleButton && isSmallDevice()) {
				<ng-container>
					<prism-icon
						id="sh-header-toolbar-hamburger-icon"
						(click)="onSidenavToggle()"
						icon="menu"
						class="sh-header-toolbar-menu-icon"
					></prism-icon>
				</ng-container>
			}
		</div>
	</span>
	<span slot="header" id="sh-header-toolbar-header-span">
		<span
			[ngClass]="isSmallDevice() ? 'prism-subtitle-1' : 'prism-headline-xs'"
			class="sh-header-toolbar-welcome-text"
			id="sh-header-toolbar-welcome-text-span"
			>{{ getHeader() }}</span
		>
		@if (isDisplayBeta()) {
			<prism-beta-indicator></prism-beta-indicator>
		}

		@if (breadCrumbs().length && showBreadCrumbs) {
			<sh-breadcrumbs
				[breadcrumbs]="breadCrumbs()"
				(breadcrumbClick)="breadCrumbRedirect($event)"
			></sh-breadcrumbs>
		}
	</span>

	<span slot="end" id="sh-header-toolbar-end-span">
		@if (showFeatureButton) {
			<prism-button
				class="prism-button"
				id="header-toolbar-feature-request-button"
				variant="standard"
				size="md"
				(click)="onClickFeatureRequest()"
			>
				{{ t('cloud.shared.header.feature-request') }}
			</prism-button>
		}
		@if (isChatAssistantEnabled()) {
			@if (!isSmallDevice()) {
				<prism-button
					class="prism-button"
					id="header-toolbar-chat-assistant-button"
					variant="standard"
					size="channel-strip"
					(click)="openChatAssistant()"
				>
					<prism-icon icon="auto_awesome" slot="icon-start"></prism-icon>
					<span> {{ t('cloud.shared.chat-assistant.intellimix-agent') }} </span>
				</prism-button>
			} @else {
				<prism-icon-button
					id="sh-header-toolbar-chat-icon-button"
					icon="auto_awesome"
					slot="icon-start"
					(click)="openChatAssistant()"
				></prism-icon-button>
			}
		}
		<ng-container #bellIconContainer></ng-container>

		@if (user()?.isAuthenticated) {
			<prism-menu>
				<button id="sh-header-toolbar-button" slot="menu-trigger" class="profile-button unbutton">
					<prism-profile-image
						data-testid="profile-image"
						[imageSrc]="getImageUrl$ | async"
						size="small"
						[firstName]="firstName()"
						[lastName]="lastName()"
						id="sh-header-toolbar-profile-image"
					>
					</prism-profile-image>
				</button>
				<prism-menu-item (click)="navigateToAccount()" id="sh-header-toolbar-account-menu-item">
					{{ t('cloud.shared.header.my-account') }}
				</prism-menu-item>
				@if (showNotifications) {
					<prism-menu-item
						(click)="navigateToNotificationsList()"
						id="sh-header-toolbar-message-center-menu-item"
						>{{ t('cloud.shared.notification.message-center') }}</prism-menu-item
					>
				}
				<prism-menu-item (click)="navigateToShureIdFaq()" id="sh-header-toolbar-faq-menu-item">{{
					t('cloud.shared.header.my-shure-id-faq')
				}}</prism-menu-item>
				<prism-menu-item (click)="logout()" id="sh-header-toolbar-sign-out-menu-item">{{
					t('cloud.shared.header.sign-out-shure-id')
				}}</prism-menu-item>
			</prism-menu>
		}
	</span>
</prism-toolbar>
